<span class="copyright-text">Copyright © <a href="https://www.trimble.com/en/about">Trimble Inc.</a> 1986-{{currentYear}}</span>